import React from 'react';
import { Button } from 'tuui';
import { IndicationContent, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from '../reviewEvents.module.scss';

export const DuplicateNameErrorModal = ({ duplicateConversionName, onBack }) => {
    return (
        <>
            <div className={styles['container']}>
                <div className={styles['title']}>
                    <FormattedMessage id="codeless.review.event.header" defaultMessage="Review Changes" />
                </div>
            </div>
            <div className={styles['error-indication']}>
                <IndicationContent
                    type={INDICATION_TYPES.ERROR}
                    contentClassName={styles['error-indication-message']}
                    displayIcon
                >
                    <FormattedMessage
                        id="codeless.save.duplicate.name.error"
                        defaultMessage="The conversion name {conversionName} is not unique. Please provide different conversion name."
                        values={{ conversionName: duplicateConversionName }}
                    />
                </IndicationContent>
            </div>
            <div className={styles['error-actions']}>
                <Button onClick={onBack} className={styles['error-retry-button']} size={Button.size.md}>
                    <FormattedMessage id="codeless.back.button" defaultMessage="Back" />
                </Button>
            </div>
        </>
    );
};
